import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import styles from './Deposite.module.sass'
import Icon from '../Icon'
import TextInput from '../TextInput'
import Checkbox from '../Checkbox'
import Successfully from './Successfully'
import Dropdown from 'components/Dropdown'
import { useDispatch, useSelector } from 'react-redux'
import DropdownWithId from 'components/DropdownCoins'
import DropdownCoins from 'components/DropdownCoins'
import DropdownDynamic from 'components/DropdownDynamic'
import { addWithdrawCrypto } from 'apis/withdraw'
import Loader from 'components/Loader'
import { toast } from 'react-toastify'
import QRCode from 'qrcode.react'
import { addDeposit } from 'apis/deposit'
import { fetchProfile } from 'store/actions'
import { fetchDepositWallets } from 'store/crypto/htx/actions'
import DropdownDynamicDeposit from 'components/DropdownDynamicDeposit'
import { fetchAvailableAssets, fetchReferenceCurrency, getDepositAddressStart } from 'store/general/assets/actions'
import { transformDepositAddresses } from 'utils/networkUtils'
import { FETCH_DEPOSIT_ADDRESS_START } from '../../store/general/assets/actionTypes.js'
import { getDepositAddress } from '../../apis/assets.js'
const languageOptions = ['sss', 'wwww']
const Deposite = ({ setVisibleDeposite, visibleDeposite }) => {
  const dispatch = useDispatch();
  const [responseData, setResponseData] = useState([])
  const [walletsOptions, setWalletsOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [visibleWithdraw, setVisibleWithdraw] = useState(true)
  const [visibleSuccessfully, setVisibleSuccessfully] = useState(false)
  const [address, setAddress] = useState('')
  const [coin, setCoin] = useState('')
  const [amount, setAmount] = useState()
  const [network, setNetwork] = useState('')
  const [depositWallets, setDepositWallets] = useState([])
  const {depositAddress} = useSelector(state => state?.assets)
  const {
    clientData,
  } = useSelector(
    (state) => ({
      clientData: state.Profile.clientData,
    })
  );
  
  // Get reference currency data for network name transformation
  const { referenceCurrency } = useSelector((state) => state?.assets);
  const { availableAssets, availableAssetsLoading } = useSelector((state) => state?.assets);
  const handleClick = () => {
    // setVisibleWithdraw(false)
    // setVisibleSuccessfully(true)
    sendData();
    setVisibleDeposite(false);
  }

  function validateInputs(){
    let status = true
    if (!coin) {
      toast.error(('Coin Is Required'))
      status = false
    }
    if (!network) {
      toast.error(('Network Is Required'))
      status = false
    }
    // if (!withdrawAmount) {
    //   toast.error(('Withdraw Amount Is Required'))
    //   status = false
    // }
    return status
  }

  const sendData = async() => {
    try {
      if (!validateInputs()) {
        return
      }
      setIsLoading(true)
      setVisibleWithdraw(false)
    } catch (error) {
      console.log(error)
      setIsLoading(false)
    }
  }


  useEffect(() => {
    // Update wallet options when available assets change
    if (referenceCurrency?.data && referenceCurrency?.data.length > 0) {
      const formattedAssets = referenceCurrency.data.filter((item) => item.chains.length > 0).map(asset => ({
        _id: asset.currency,
        asset: asset.currency.toUpperCase()
      }))
      setWalletsOptions(formattedAssets)
    }
  }, [availableAssets])

  useEffect(()=>{
    setAmount(coin?.amount)
    setAddress('');
    if(coin._id && network.originalChain){
      dispatch(getDepositAddressStart(coin?._id, network?.originalChain))
    }
    if(!coin?._id){
     setNetwork('');
    }
      // const addresses = clientData?.htx?.depositAddresses?.filter((addr) => {
      //   return addr?.currency?.toLowerCase() === coin?._id?.toLowerCase()
      // })
      // const transformedAddresses = referenceCurrency?.data ? 
      //   transformDepositAddresses(addresses, referenceCurrency?.data) : 
      //   addresses;
        
        const availableNetworks = referenceCurrency?.data?.find((item) => item.currency?.toLowerCase() === coin?._id?.toLowerCase())?.chains.map(chain=> {
          return {
          displayChain: chain.displayName,
          originalChain: chain.chain
        }
      })
      setDepositWallets(availableNetworks);
    

  }, [coin, referenceCurrency, network])

  useEffect(()=>{
   setAddress(depositAddress?.address)
  }, [network,depositAddress,coin,address])

  useEffect(() => {
    if (visibleDeposite && !clientData?.htx?.depositAddresses?.length > 0) {
      dispatch(fetchProfile());
    }
    
    // Fetch reference currency data if not already loaded
    if (visibleDeposite && !referenceCurrency?.data) {
      dispatch(fetchReferenceCurrency());
    }
  }, [visibleDeposite, referenceCurrency]);

  return (
    <>
      {isLoading && <Loader />}
      {visibleWithdraw && (
        <div className={styles.withdraw}>
          <div className={cn('h4', styles.title)}>
            <Icon name="arrow-left" size="32" />
            Deposit {coin?.asset?.toUpperCase() || ""}
          </div>
          <div>
            <label className={styles.label}>Coin/Wallet</label>
            <DropdownCoins
              className={styles.dropdown}
              classDropdownHead={styles.dropdownHead}
              value={coin}
              setValue={setCoin}
              options={walletsOptions}
            />
          </div>
          <div>
            <label className={styles.label}>Network</label>
            {/* <DropdownDynamic
              className={styles.dropdown}
              classDropdownHead={styles.dropdownHead}
              value={network}
              setValue={setNetwork}
              options={depositWallets}
              // uniqueName={'chainId?.name'}
              // uniqueId={'chainId?._id'}
            /> */}
            <DropdownDynamicDeposit
              className={styles.dropdown}
              classDropdownHead={styles.dropdownHead}
              value={network}
              setValue={setNetwork}
              options={depositWallets}
              // uniqueName={'chainId?.name'}
              // uniqueId={'chainId?._id'}
            />
          </div>

          {/* <TextInput
            className={styles.field}
            label="address"
            name="address"
            type="text"
            note="Do not send Tether USD unless you are certain the destination supports
        TRC-20 transactions. If it does not, you could permanently lose access
        to your coins."
            onChange={(e)=>setAddress(e?.target?.value)}
            value={address}
            required
            disabled
          /> */}
          {address && (
            <div className={cn(styles.addressText, styles.field)}>
              <span title={address}>{address}</span>
              <button onClick={() => {
                navigator.clipboard.writeText(address);
                toast.success('Text copied to clipboard successfully');
              }}>
                <Icon name="copy" size="24"/>
              </button>
          </div>
)}

          {/* <div className={styles.box}>
            <TextInput
              className={styles.field}
              label="Amount to withdraw"
              name="amount"
              type="number"
              note="$1,000,000.00 daily withdrawal limit remaining."
              onChange={(e)=>setWithdrawAmount(e?.target?.value)}
              value={withdrawAmount}
              required
            />
            <button className={cn('button-stroke button-small', styles.button)}>
              Max amount
            </button>
          </div> */}
          {
            address &&
            <>
              <div className={styles.qrWrapper}>
                <QRCode size={250} value={network?.address} renderAs="canvas" className='mx-auto' />
              </div>
              <div className={styles.noteWrapper}>
                <p className={styles.note}>{(`Send only ${coin?.asset} to this deposit address.`)}</p>
                <p className={styles.note}>{(`Ensure the network is ${depositAddress?.chain}.`)}</p>
                <p className={styles.note}>
                  {("Do not send NFT to this address. Learn how to deposit NFTs")}
                </p>
              </div>
            </>
          }
          <button
            type="submit"
            disabled={isLoading}
            className={cn('button', styles.button)}
            onClick={handleClick}
          >
            {isLoading ? <Loader /> : 'Deposit' }
          </button>
        </div>
      )}
      {visibleSuccessfully && <Successfully responseData={responseData} handleClick={handleClick}/>}
    </>
  )
}

export default Deposite
